
export default function convertBase64ToBlob(base64Img){
            let base64Data = base64Img.slice(base64Img.indexOf(',') + 1);
            let sliceSize = 1024;
            let byteCharacters = atob(base64Data);
            let bytesLength = byteCharacters.length;
            let slicesCount = Math.ceil(bytesLength / sliceSize);
            let byteArrays = new Array(slicesCount);
            for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
                let begin = sliceIndex * sliceSize;
                let end = Math.min(begin + sliceSize, bytesLength);

                let bytes = new Array(end - begin);
                for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                    bytes[i] = byteCharacters[offset].charCodeAt(0);
                }
                byteArrays[sliceIndex] = new Uint8Array(bytes);
            }
            let convertBase64ToBlob = new Blob(byteArrays, { type: 'image/jpeg' });
                convertBase64ToBlob.name = new Date().getTime() + '_adminComments.jpeg';
                convertBase64ToBlob.lastModified = new Date();

            return new File([convertBase64ToBlob], convertBase64ToBlob.name, {
                type: convertBase64ToBlob.type,
            });
}